import { Palette } from '@material-ui/core/styles/createPalette';
import * as React from 'react';
import styled from 'styled-components';
import { DSPaperProps, DSPaper } from '../Paper';
import { DSTypography } from '../Typography';

type PlannerStatus = 'general' | 'ready' | 'required' | 'scheduled' | 'supported';

export type DSPlannerItemFields = {
    copy: string;
    icon: string;
    status: PlannerStatus;
};

export type DSContextColorKeys = keyof Pick<Palette, 'error' | 'info' | 'neutral' | 'success' | 'warning'>;

const plannerStatusColors: Record<PlannerStatus, DSContextColorKeys> = {
    general: 'neutral',
    ready: 'warning',
    required: 'error',
    scheduled: 'success',
    supported: 'info',
};

const useToggle = (initial = false) => React.useReducer((state: boolean) => !state, initial);

const StyledPlannerItem = styled(DSPaper)<Omit<DSPlannerItemProps, 'copy' | 'icon'>>`
    border-left: 3px solid ${({ status, theme }) => theme.palette[plannerStatusColors[status]].main};
    background-color: ${({ status, theme }) => theme.palette.contextBackgrounds[plannerStatusColors[status]]};
    padding: 8px;
    margin: 4px 0px;
    display: flex;
    color: black;
    cursor: pointer;
`;

const StyledCopy = styled(DSTypography).attrs({
    component: 'p',
})`
    color: black;
`;

export type DSPlannerItemProps = DSPaperProps & DSPlannerItemFields;

export const DSPlannerItem: React.FC<DSPlannerItemProps> = ({ copy, icon, ...rest }) => {
    const [raised, toggleRaised] = useToggle();
    return (
        <StyledPlannerItem
            elevation={raised ? 4 : 2}
            square
            onMouseEnter={toggleRaised}
            onMouseLeave={toggleRaised}
            {...rest}
        >
            <img height="24px" src={icon} style={{ marginRight: '8px' }} width="24px" />
            <StyledCopy>{copy}</StyledCopy>
        </StyledPlannerItem>
    );
};
DSPlannerItem.displayName = 'DSPlannerItem';
